export const version = '0.0.1';
export const prefix = 'Ha';
